import { useOutletContext } from 'react-router-dom'
import useTheme from 'hooks/useTheme'
import useLanguage from 'hooks/useLanguage'
import { SocialNav } from 'components/shared/SocialNav'
import { IPublicLayoutContext } from 'components/layouts/PublicLayout'

export const Contact = () => {
  const { theme } = useTheme()
  const { language } = useLanguage()
  const { store } = useOutletContext<IPublicLayoutContext>()

  return (
    <div
      style={{
        minHeight: '100vh',
        background: theme.background.primary,
        color: theme.text.primary,
        fontFamily: theme.font.family,
      }}
    >
      <SocialNav />
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>
        <h1 style={{ fontWeight: 300, marginBottom: 20 }}>{language['CONTACT_US_TITLE']}</h1>

        <div
          style={{
            background: theme.background.secondary,
            borderRadius: 8,
            padding: 24,
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        >
          {store?.name && (
            <div>
              <div style={{ fontSize: 12, color: theme.text.tertiary, marginBottom: 4 }}>{language['HOME']}</div>
              <div style={{ fontSize: 15 }}>{store.name}</div>
            </div>
          )}
          {store?.address && (
            <div>
              <div style={{ fontSize: 12, color: theme.text.tertiary, marginBottom: 4 }}>{language['CONTACT_ADDRESS']}</div>
              <div style={{ fontSize: 15 }}>{store.address}</div>
            </div>
          )}
          {store?.contact && (
            <div>
              <div style={{ fontSize: 12, color: theme.text.tertiary, marginBottom: 4 }}>{language['CONTACT_PHONE']}</div>
              <div style={{ fontSize: 15 }}>{store.contact}</div>
            </div>
          )}
          {!store && (
            <div style={{ fontSize: 13, color: theme.text.tertiary }}>{language['CONTACT_INFO_UNAVAILABLE']}</div>
          )}
        </div>
      </div>
    </div>
  )
}
